import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderJsonEditorModalComponent } from './json-editor-modal.component';
import { RappiderModalModule } from '../modal/modal.module';
import { RappiderButtonModule } from '../button/button.module';
import { RappiderCodeEditorModule } from '../code-editor/code-editor.module';
import { FormsModule } from '@angular/forms';
import { RappiderMonacoEditorModule } from '../monaco-editor/monaco-editor.module';

@NgModule({
  declarations: [
    RappiderJsonEditorModalComponent
  ],
  imports: [
    CommonModule,
    RappiderButtonModule,
    RappiderModalModule,
    RappiderCodeEditorModule,
    FormsModule,
    RappiderMonacoEditorModule
  ],
  exports: [
    RappiderJsonEditorModalComponent
  ]
})
export class RappiderJsonEditorModalModule { }
